<template>
  <div
    :class="[
      'toast-custom',
      {
        'is-error': props.isError,
        'is-warning': props.isWarning,
        'is-notice': props.isNotice,
        'is-disabled': props.isDisabled,
      },
      props.className,
    ]"
    :style="[props.inlineStyles]"
  >
    <!-- <div class="toast-custom-icon">
      <div class="toast-custom-icon-image" />
    </div> -->
    <span class="toast-custom-text">
      {{ props.label }}
    </span>
    <div class="toast-custom-icon-close">
      <div class="toast-custom-icon-image-close" @click="props.onClick" />
    </div>
  </div>
</template>

<script setup>
// Component name
const componentName = 'Toast';

// Component props types: String, Number, Boolean, Array, Object, Function, Promise
const props = defineProps({
  className: {
    type: String,
  },
  inlineStyles: {
    type: Object,
    default: function () {
      return {
        // Style
      };
    },
  },
  label: {
    type: String,
    default: 'label',
  },
  isError: {
    type: Boolean,
  },
  isWarning: {
    type: Boolean,
  },
  isNotice: {
    type: Boolean,
  },
  isDisabled: {
    type: Boolean,
  },
  onClick: {
    type: Function,
    default: function () {},
  },
});
</script>

<style lang="scss">
.toast-custom {
  /* Parent style   ------------------------------ */
  display: flex;
  justify-content: baseline;
  align-items: center;
  min-width: $specific-toast-min-width;
  /* min-height: 98px; */
  padding: $py-4 $px-4 $py-4 $px-4;
  gap: $space-x-4;
  border: 1px solid $semantic-color-status-success-border;
  border-radius: $specific-toast-rounded;
  background-color: $semantic-color-status-success-background;
  box-shadow: $specific-toast-shadow-x $specific-toast-shadow-y
    $specific-toast-shadow-blur $specific-toast-shadow-spread
    $specific-toast-shadow-color;

  .toast-custom-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: $rounded-full;
    background-color: $semantic-color-status-success-foreground;

    .toast-custom-icon-image {
      background-image: url('/images/icons/ic-checked-circle-green.svg');
      background-repeat: no-repeat;
      background-position: center;
      width: $semantic-dimension-icon-sm;
      height: $semantic-dimension-icon-sm;
    }
  }

  .toast-custom-text {
    font-family: $typography-font-family-primary;
    font-weight: 500;
    font-size: $semantic-text-body-md-font-size;
    line-height: $semantic-text-body-md-line-height;
    color: $semantic-color-text-content-body;
    word-break: break-word;
    flex: 1;
  }

  .toast-custom-icon-close {
    display: flex;
    justify-content: center;
    align-items: center;
    width: $semantic-dimension-icon-md;
    height: $semantic-dimension-icon-md;

    .toast-custom-icon-image-close {
      background-image: url('/images/icons/ic-close-green-outline.svg');
      width: 14px;
      height: 14px;
      cursor: pointer;
    }
  }

  /* Modifier style ------------------------------ */
  &.is-error {
    background-color: $semantic-color-status-error-background;
    border: 1px solid $semantic-color-status-error-border;
    .toast-custom-text {
      color: $semantic-color-status-error-border-validation;
    }
    .toast-custom-icon {
      background-color: $semantic-color-status-error-foreground;
      .toast-custom-icon-image {
        background-image: url('/images/icons/ic-circle-x-mask-red.svg');
      }
    }
    .toast-custom-icon-close {
      .toast-custom-icon-image-close {
        background-image: url('/images/icons/ic-close-red-outline.svg');
      }
    }
  }

  &.is-warning {
    background-color: $semantic-color-status-warning-background;
    border: 1px solid $semantic-color-status-warning-border;
    .toast-custom-icon {
      background-color: $semantic-color-status-warning-foreground;
      .toast-custom-icon-image {
        background-image: url('/images/icons/ic-exclamtion-outline.svg');
      }
    }
    .toast-custom-icon-close {
      .toast-custom-icon-image-close {
        background-image: url('/images/icons/ic-close-outline-warn.svg');
      }
    }
  }

  &.is-notice {
    background-color: $semantic-color-status-notice-background;
    border: 1px solid $semantic-color-status-notice-border;

    .toast-custom-text {
      color: $semantic-color-text-content-body;
    }
    .toast-custom-icon {
      background-color: $semantic-color-status-notice-foreground;
      .toast-custom-icon-image {
        background-image: url('/images/icons/ic-information-outline.svg');
      }
    }
    .toast-custom-icon-close {
      .toast-custom-icon-image-close {
        background-image: url('/images/icons/ic-info-toast-close.svg');
      }
    }
  }

  &.is-disabled {
    background-color: $semantic-color-status-disabled-background;
    border: 1px solid $semantic-color-status-disabled-border;

    .toast-custom-icon {
      background-color: $semantic-color-status-disabled-foreground-emphasize-fill;
      .toast-custom-icon-image {
        background-image: url('/images/icons/ic-information-outline.svg');
      }
    }
    .toast-custom-icon-close {
      .toast-custom-icon-image-close {
        background-image: url('/images/icons/ic-close-outline-gray.svg');
      }
    }
  }
}
</style>
